import React from 'react'

const Footer = () => {
  return (
    <div><footer>
    <div className="container">
      <div className="top-footer">
        <div className="row">
          <div className="col-lg-4 col-md-6 col-sm-6">
            <div className="widget widget-about">
              <img src="assets/img/logo3.png" alt=""  style={{ width: "100px", height: "110px" }} />
              <p>
                Vivamus porta efficitur nibh nec convallis. Vestibulum egestas
                eleifend justo. Ut tellus ipsum, accumsan
              </p>
            </div>
            {/*widget-about end*/}
          </div>
          <div className="col-lg-4 col-md-6 col-sm-6">
            <div className="widget widget-contact">
              <ul className="contact-add">
                <li>
                  <div className="contact-info">
                    <img src="assets/img/icon1.png" alt="" />
                    <div className="contact-tt">
                      <h4>Call</h4>
                      <span>+2 342 5446 67</span>
                    </div>
                  </div>
                  {/*contact-info end*/}
                </li>
                <li>
                  <div className="contact-info">
                    <img src="assets/img/icon2.png" alt="" />
                    <div className="contact-tt">
                      <h4>Work Time</h4>
                      <span>Mon - Fri 8 AM - 5 PM</span>
                    </div>
                  </div>
                  {/*contact-info end*/}
                </li>
                <li>
                  <div className="contact-info">
                    <img src="assets/img/icon3.png" alt="" />
                    <div className="contact-tt">
                      <h4>Address</h4>
                      <span>Franklin St, Greenpoint Ave</span>
                    </div>
                  </div>
                  {/*contact-info end*/}
                </li>
              </ul>
            </div>
            {/*widget-contact end*/}
          </div>
          <div className="col-lg-4 col-md-6 col-sm-6">
            <div className="widget widget-links">
              <h3 className="widget-title">Quick Links</h3>
              <ul>
                <li>
                  <a href="/about" title="">
                    About Us
                  </a>
                </li>
                <li>
                  <a href="/classes" title="">
                    Our Classes
                  </a>
                </li>
                <li>
                  <a href="/" title="">
                    School Teachers
                  </a>
                </li>
                <li>
                  <a href="/events" title="">
                    Recent Events
                  </a>
                </li>
                <li>
                  <a href="/blog" title="">
                    Our News
                  </a>
                </li>
                <li>
                  <a href="/schedule" title="">
                    Schedule
                  </a>
                </li>
              </ul>
            </div>
            {/*widget-links end*/}
          </div>
        </div>
      </div>
      {/*top-footer end*/}
      <div className="bottom-footer">
        <div className="row align-items-center">
          <div className="col-lg-6 col-md-6 col-sm-6">
            <p>© Copyrights 2025 Trinity All rights reserved</p>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="social-links">
              <li>
                <a href="#" title="">
                  <i className="fa-facebook-f fab" />
                </a>
              </li>
              <li>
                <a href="#" title="">
                  <i className="fa-linkedin-in fab" />
                </a>
              </li>
              <li>
                <a href="#" title="">
                  <i className="fa-instagram fab" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/*bottom-footer end*/}
    </div>
  </footer></div>
  )
}

export default Footer